const pickBkgClass = (themeName, colorLevel) => {
	if (themeName === 'white' && colorLevel === 'hard') return 'whiteHardBkg';
	else if (themeName === 'white' && colorLevel === 'soft')
		return 'whiteSoftBkg';
	else if (themeName === 'black' && colorLevel === 'hard')
		return 'blackHardBkg';
	else if (themeName === 'black' && colorLevel === 'soft')
		return 'blackSoftBkg';
	else if (themeName === 'ocean' && colorLevel === 'hard')
		return 'oceanHardBkg';
	else if (themeName === 'ocean' && colorLevel === 'soft')
		return 'oceanSoftBkg';
	else if (themeName === 'viola' && colorLevel === 'hard')
		return 'violaHardBkg';
	else if (themeName === 'viola' && colorLevel === 'soft')
		return 'violaSoftBkg';
};

export default pickBkgClass;
